<script lang="ts">
  import type { ComparativePrice } from "../../../../types/CinemaProductsDto.types.ts";
  import { showComparativeStrikethrough } from "../../e3823.ts";

  interface Props {
    comparative: ComparativePrice;
  }

  const { comparative }: Props = $props();
</script>

<div>
  {#if comparative.isUvp}
    <span class="prefix">UVP</span>
  {/if}
  <span
    class="price"
    class:strikethrough={showComparativeStrikethrough(comparative.isUvp)}
    >{comparative.price}</span
  >
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  div {
    display: inline-flex;
    flex-wrap: nowrap;
  }

  .prefix {
    padding-right: tokens.$oc-semantic-spacing-50;
  }

  .price {
    text-decoration: none;
    white-space: nowrap;
  }

  .strikethrough {
    text-decoration: line-through;
  }
</style>
